export const triggerSidenavItemAnalyticsClick = (eventLabel) => {
    const analyticsData = {
        applicationName: 'appheader',
        elementPath: 'appheader',
        elementType: 'sidenav navigation',
        action: 'click',
        eventLabel,
    };

    const eventAction = `${analyticsData.elementPath} | ${analyticsData.elementType} : ${analyticsData.action}`;

     
    window?._analytics?.trackEvent(
        analyticsData.applicationName,
        eventAction,
        analyticsData.eventLabel,
        {},
    );
};

export default triggerSidenavItemAnalyticsClick;
